import { Badge } from "@/components/kit";
import { C, COMMISSION_LABELS, commissionColor, date, eur } from "@/lib/format";

export function CommissionItem({ c, showAgent, children }) {
  return (
    <div
      data-testid={`commission-item-${c.id}`}
      className="flex flex-col gap-1 rounded-[20px] border bg-[#1E1E1E] p-4"
      style={{ borderColor: c.flagged ? C.warning : C.border }}
    >
      <div className="flex items-center justify-between">
        <span className="t-caption !text-[#D4AF37]">
          {c.type === "commission" ? "COMMISSION" : "PARRAINAGE"} · {c.recommendation_number}
        </span>
        <span className="t-caption">{date(c.created_at)}</span>
      </div>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1">
          {showAgent && <h3 className="t-h3">{c.agent_name}</h3>}
          <p className="t-caption">
            {c.type === "commission"
              ? `${String(c.rate ?? 0).replace(".", ",")} % de ${eur(c.contract_amount)}`
              : `Filleul : ${c.source_agent_name ?? "—"}`}
          </p>
        </div>
        <span className="t-h2 tabular-nums" style={{ color: c.status === "paid" ? C.success : C.onSurface }}>
          {eur(c.amount)}
        </span>
      </div>
      <div className="mt-1 flex flex-wrap items-center gap-2">
        <Badge testID={`commission-status-${c.id}`} label={COMMISSION_LABELS[c.status]} color={commissionColor(c.status)} />
        {c.flagged ? <Badge label="À vérifier" color={C.warning} /> : null}
        {showAgent && c.agent_has_rib === false ? <Badge label="RIB manquant" color={C.error} /> : null}
        {c.paid_at ? (
          <span className="t-caption">
            Payée le {date(c.paid_at)}
            {c.payment_reference ? ` · Réf. ${c.payment_reference}` : ""}
          </span>
        ) : null}
      </div>
      {children}
    </div>
  );
}
